import { Edit, SimpleForm, TextInput, useRecordContext, SelectInput, required } from 'react-admin';

import { Batch_Templates } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { BATCH_TEMPLATE_TYPE, STATUSES } from '../../common/constants';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import SlugInput from '../../common/inputs/SlugInput';
import { ProgramAutocomplete } from '../../common/inputs/autoCompleteInputs/ProgramAutoComplete';

const BatchTemplateEdit = () => {
    const { isUpdatable } = useIsPermission('BATCH_TAMPLATE');
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit title={<BatchTitle />} mutationMode={'pessimistic'}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="title" fullWidth validate={[required()]} />
                    <SlugInput source="slug" fullWidth />
                    <SelectInput
                        source="status"
                        label={'Status'}
                        fullWidth
                        validate={[required()]}
                        choices={STATUSES}
                    />
                    <SelectInput
                        source="type"
                        label={'Type'}
                        fullWidth
                        validate={[required()]}
                        choices={BATCH_TEMPLATE_TYPE}
                    />
                    <ProgramAutocomplete validate={[required()]} />
                    <HTMLEditorInput
                        source={'description'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const BatchTitle = () => {
    const record = useRecordContext<Batch_Templates>();
    return record ? <span>{record.title}</span> : null;
};

export default BatchTemplateEdit;
